import React from 'react';
import { AuthorType } from '@marty-js/api-sdk/types';
import styled from 'styled-components';
import { useTranslation } from '@marty-js/design/src/utils/translation';
import { SocialProps } from '@marty-js/design/src/molecules/socials';
import { useLinkComponent } from '@marty-js/design/src/utils/component';
// import { Cta } from '@marty-js/design/src/molecules/cta';
import Twitter from '@marty-js/design/src/icons/twitter';
import Linkedin from '@marty-js/design/src/icons/linkedin';
import { Image } from './image/image';
import { NavLink } from './nav-link';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: var(--spacer-s) 0 var(--spacer-fluid);
  gap: var(--spacer-fluid);
`;

const Author = styled.div`
  background: var(--color-alt-4);
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px var(--color-box-shadow);
  display: flex;
  flex-direction: column;
  gap: var(--spacer-fluid);
  padding: var(--spacer) var(--spacer);
  align-items: start;
`;

const AuthorHeader = styled.div`
  align-items: center;
  display: flex;
  gap: var(--spacer-s);
  width: 100%;
`;

const AuthorImage = styled.div`
  border-radius: 50%;
  height: 60px;
  min-height: 60px;
  min-width: 60px;
  overflow: hidden;
  width: 60px;
`;

const AuthorInformations = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.62;
  margin-right: auto;

  a {
    transition: color 0.3s;

    &:hover {
      color: var(--theme-color-primary);
    }
  }
`;

const AuthorInformationsSkills = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const AuthorSocialMedia = styled.div`
  display: flex;
  gap: var(--spacer-fluid);
`;

// const AuthorDescription = styled.p`
//   line-height: 1.62;
//   margin: 0;
// `;

interface Props {
  authors: AuthorType[];
}
export const AuthorDetailed = ({ authors }: React.PropsWithChildren<Props>) => {
  const t = useTranslation();
  // const vowelsRegex = /^[aeiouy].*/i;

  const LinkComponent = useLinkComponent();

  return (
    <Wrapper>
      {authors?.map((author, index) => {
        const socials = author?.mainDataSheet?.groups.find((group) => group.shortSlug === 'social_network');

        const twitter = socials?.attributes.find(
          (attribute) => attribute.shortSlug === 'twitter' && attribute?.value,
        ) as SocialProps | null;
        const linkedin = socials?.attributes.find(
          (attribute) => attribute.shortSlug === 'linkedin' && attribute?.value,
        ) as SocialProps | null;

        const miscellaneous = author?.mainDataSheet?.groups.find((group) => group.shortSlug === 'divers');
        const skill = miscellaneous?.attributes.find((attribute) => attribute.shortSlug === 'skill')?.value;

        // const description = author?.summary || t('sdk.author.missing_summary');

        return (
          <Author key={`author-detailed-${index}`}>
            <AuthorHeader>
              <AuthorImage>
                <Image
                  alt={author.title}
                  imageId={author.imageId}
                  mobileHeight={60}
                  mobileWidth={60}
                  desktopHeight={60}
                  desktopWidth={60}
                />
              </AuthorImage>
              <AuthorInformations>
                <div>
                  {t('sdk.author.by')}&nbsp;
                  <LinkComponent href={`${author.url}`}>
                    <strong>{author.title}</strong>
                  </LinkComponent>
                </div>
                {skill && <AuthorInformationsSkills>{skill}</AuthorInformationsSkills>}
              </AuthorInformations>
              <AuthorSocialMedia>
                {twitter && (
                  <NavLink href={`https://twitter.com/${twitter.value}`} rel={['nofollow', 'noopener']} openInNewWindow>
                    <Twitter width={22} height={22} color="var(--theme-color-primary)" />
                  </NavLink>
                )}
                {linkedin && (
                  <NavLink
                    href={`https://www.linkedin.com/in/${linkedin.value}`}
                    rel={['nofollow', 'noopener']}
                    openInNewWindow
                  >
                    <Linkedin width={22} height={22} color="var(--theme-color-primary)" />
                  </NavLink>
                )}
              </AuthorSocialMedia>
            </AuthorHeader>
            {/* {description && <AuthorDescription>{description}</AuthorDescription>}
            <Cta className="mod-blue mod-empty" href={`${author.url}`}>
              {vowelsRegex?.test(author.title)
                ? t('sdk.author.access_vowel', {
                    name: author.title,
                  })
                : t('sdk.author.access', {
                    name: author.title,
                  })}
            </Cta> */}
          </Author>
        );
      })}
    </Wrapper>
  );
};
